import type { IReflectionQuestionBaseDto, IReflectionQuestionBaseModel } from "@/3514/types"

function reflectionBaseAdapter(dto: IReflectionQuestionBaseDto): IReflectionQuestionBaseModel {
    return {
        componentType: dto.component_type,
        content: dto.content,
        order: dto.order,
        prompt: dto.prompt,
        question: dto.question,
        isResponseRequired: dto.response_required,
        uuid: dto.uuid
    }
}

export { reflectionBaseAdapter }
